/**
 * Loading spinner.
 * Detects browser and uses supported image format.
 */
import { detect } from "detect-browser";

export default {
  name: "LoadingSpinner",
  props: {
    height: { type: String, default: "" },
    width: { type: String, default: "" },
  },
  computed: {
    /**
     * Detect whether the browser supports animated SVGs.
     * AFAIK only Microsoft browsers don't. Naturally.
     */
    browserSupportsAnimatedSVG() {
      const browser = detect();
      if (browser.name === "ie" || browser.name === "edge") {
        return false;
      }
      return true;
    },

    /**
     * Set inline styles for the spinner.
     * Currently allows width and height to be set.
     */
    style() {
      if (this.height && this.width) {
        return { height: this.height, width: this.width };
      }
      return {};
    },
  },
};
